import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {useReducedMotionLottie} from 'hooks';

type Props = {
  open: boolean;
  onClose: () => void;
  lottie?: object | null;
  scanPath: string;
};

export function AutoFillModalContent({open, onClose, lottie, scanPath}: Props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const reducedMotion = useReducedMotionLottie({
    stopFrame: 90,
  });

  const handleScan = () => {
    onClose();
    navigate(scanPath);
  };

  const body = (
    <div className="mx-auto flex w-full max-w-[600px] flex-col items-stretch">
      {lottie && (
        <div className="mx-auto mb-8 mt-6 h-[224px] w-[224px]">
          <Lottie
            animationData={lottie}
            className="h-full w-full"
            aria-hidden="true"
            {...reducedMotion}
          />
        </div>
      )}
      <div className="mx-auto flex flex-col gap-5">
        <Button type="button" onClick={handleScan}>
          {t('scan_your_document')}
        </Button>
        <Button variant="secondary" type="button" onClick={onClose}>
          {t('complete_the_form_manually')}
        </Button>
      </div>
    </div>
  );

  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={t('do_you_want_auto_fill_form')}
      description={t('auto_fill_form_modal_text')}
      dialogClassName="max-w-[530px] sm:max-w-[530px]"
      contentClassName="mx-auto w-full max-w-[530px] px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
      descriptionClassName="mb-6"
    >
      {body}
    </ResponsiveSheet>
  );
}
